import AnalyticController from "./analytic-controller";
import { withAuthRedirect } from "hoc/AuthRedirect";
import { connect } from "react-redux";
import { compose } from "redux";
import { getValue } from "store/languages";
import { getStartDate, getEndDate } from "selectors/calendar-selector";
import { setGroupingByPeriod } from "store/calendar"
import { setLeftMenuComponent, setRemoveLeftMenuComponent, setRightMenuComponent, setRemoveRightMenuComponent, setShowLeftMenu, setShowRightMenu } from 'store/side-bar';
import { getTopics, getTopicsFiltersSelectorTree } from "selectors/theme-selector";
import { setSelectedTopics, setSelectedTopicsAll, setSelectedSubtopicsAll } from "store/topic-menu"
import { getSelectedTopicsUUID, getSelectedSubTopicsUUID } from "selectors/topic-menu-selector";
import { setMenus } from "store/settings-menu";
import { getMyTopics, setThemeTableData } from "store/theme-settings";
import { setShowPanel } from "store/header";
import { getDataByType, setAnalyticIsFetching, setFirstMax, setSecondMax, setFirstLimit } from "store/extended-analytic";
import { getExtendedData, getExtendedDataSecond, getExtendedDataS, getExtendedThird } from "selectors/extended-selector";
import { getExtendedMetric } from "selectors/metrics-selector";
import { setIsFilterChanged, getCompanyTags, setOneMyFilter, setSelectedTopics as setSelectedFiltersTopics, setPageName, getFiltersStatistics, setAddSelectedMyFilter, setMySelectedTopicsFilter } from "store/filters";
import { setIsReturnedBack, setReturnBackPostCount } from "store/return-back-button";
import { getToipicFiltersCountsSelector } from "selectors/filters-selector";

let mapStateToProps = (state) => {

    return {
        selected: state.settingsPageMenu.selectedMenuItem,
        selectedLanguage: state.languages.selectedLanguage,
        startDate: getStartDate(state),
        endDate: getEndDate(state),
        grouping: state.Calendar.grouping,
        leftMenuComponent: state.SideBarMenu.leftMenuComponent,
        rightMenuComponent: state.SideBarMenu.rightMenuComponent,
        topicData: getTopics(state),
        topics: getTopicsFiltersSelectorTree(state),
        selectedTopics: getSelectedTopicsUUID(state),
        selectedTopicsItems: state.TopicMenu.selectedTopics,
        selectedSubtopics: getSelectedSubTopicsUUID(state),
        menuItems: state.ExtendedAnalytic.menuItems,
        selectedItems: state.TopicMenu.selectedTopics,
        searchList: state.SearchText.searchList,
        tags: state.Filters.tags,
        isFetchingAnalytic: state.ExtendedAnalytic.isFetching,
        first: getExtendedData(state, 'first'),
        second: getExtendedDataS(state, 'second'),
        third: getExtendedThird(state, 'third'),
        metric: getExtendedMetric(state, 'metric'),
        isChanged: state.Filters.isChanged,
        selectedMyFilter: state.Filters.selectedMyFilter,
        locationsName: state.ExtendedAnalytic.locationsName,
        deviceType: state.header.deviceType,
        topicFilters: getToipicFiltersCountsSelector(state),
        firstLimit: state.ExtendedAnalytic.firstLimit
        //firstMax: state.ExtendedAnalytic.firstMax,
        //secondMax: state.ExtendedAnalytic.secondMax
    }
}

const AnalyticContainer = compose(connect(mapStateToProps, {
    getValue, 
    setRightMenuComponent,
    setRemoveRightMenuComponent,
    setShowRightMenu,
    setShowLeftMenu,
    setLeftMenuComponent,
    setRemoveLeftMenuComponent,
    getMyTopics,
    setSelectedTopicsAll,
    setSelectedSubtopicsAll,
    setMenus,
    setShowPanel,
    getDataByType,
    setAnalyticIsFetching,
    getFiltersStatistics,
    setSelectedFiltersTopics,
    setIsFilterChanged,
    setPageName,
    setIsReturnedBack, 
    setReturnBackPostCount,
    setGroupingByPeriod, 
    setAddSelectedMyFilter,
    setMySelectedTopicsFilter,
    setFirstMax, 
    setSecondMax, setOneMyFilter, setFirstLimit }),withAuthRedirect)(AnalyticController);
export default AnalyticContainer;